// extracted by mini-css-extract-plugin
export default {"createdDate":"OfferDatesBlock_createdDate__vA-Ah","dateEnd":"OfferDatesBlock_dateEnd__4fYnA"};